module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dental-health-month"
  }, [_c('div', {
    staticClass: "form-dental-health-month__container"
  }, [_vm._m(0), (_vm.formSubmitted) ? _c('div', {
    staticClass: "form-dental-health-month__success-message"
  }, [_vm._v("Thanks for submitting our form, we will get back to you as soon as possible!")]) : _vm._e(), _c('div', {
    staticClass: "form-dental-health-month__formtitle"
  }, [_vm._v("Please submit your information to have a special travel toothbrush (great for a backpack or sports gym bag) mailed directly to your home      ")]), (_vm.formallSubmitted) ? _c('form', {
    staticClass: "form-dental-health-month__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-dental-health-month__two-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('firstname')
    },
    attrs: {
      "name": "firstname",
      "type": "text",
      "placeholder": "Parent First Name"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstname')),
      expression: "errors.has('firstname')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))])]), _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('lastname')
    },
    attrs: {
      "name": "lastname",
      "type": "text",
      "placeholder": "Parent Last Name"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastname')),
      expression: "errors.has('lastname')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('lastname')))])])]), _c('div', {
    staticClass: "form-dental-health-month__one-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childsname),
      expression: "childsname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('childsname')
    },
    attrs: {
      "name": "childsname",
      "type": "text",
      "placeholder": "Child Name"
    },
    domProps: {
      "value": (_vm.childsname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.childsname = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('childsname')),
      expression: "errors.has('childsname')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('childsname')))])])]), _c('div', {
    staticClass: "form-dental-health-month__one-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingaddress),
      expression: "mailingaddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('mailingaddress')
    },
    attrs: {
      "name": "mailingaddress",
      "type": "text",
      "placeholder": "Mailing Address"
    },
    domProps: {
      "value": (_vm.mailingaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailingaddress = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mailingaddress')),
      expression: "errors.has('mailingaddress')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('mailingaddress')))])])]), _c('div', {
    staticClass: "form-dental-health-month__three-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'input': true, 'form-dental-health-month__input--error': _vm.errors.has('city')
    },
    attrs: {
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))])]), _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "type": "text",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state')),
      expression: "errors.has('state')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state')))])]), _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('zip')
    },
    attrs: {
      "name": "zip",
      "type": "text",
      "placeholder": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))])])]), _c('div', {
    staticClass: "form-dental-health-month__three-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.age),
      expression: "age"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('age')
    },
    attrs: {
      "name": "age",
      "type": "text",
      "placeholder": "Age"
    },
    domProps: {
      "value": (_vm.age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.age = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('age')),
      expression: "errors.has('age')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('age')))])]), _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolname),
      expression: "schoolname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('schoolname')
    },
    attrs: {
      "name": "schoolname",
      "type": "text",
      "placeholder": "School Name"
    },
    domProps: {
      "value": (_vm.schoolname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolname = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('schoolname')),
      expression: "errors.has('schoolname')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('schoolname')))])]), _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('grade')
    },
    attrs: {
      "name": "grade",
      "type": "text",
      "placeholder": "Grade"
    },
    domProps: {
      "value": (_vm.grade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grade = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('grade')),
      expression: "errors.has('grade')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('grade')))])])]), _c('div', {
    staticClass: "form-dental-health-month__one-wide"
  }, [_c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentemail),
      expression: "parentemail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-dental-health-month__input",
    class: {
      'form-dental-health-month__input--error': _vm.errors.has('parentemail')
    },
    attrs: {
      "name": "parentemail",
      "type": "text",
      "placeholder": "Parent Email"
    },
    domProps: {
      "value": (_vm.parentemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentemail = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('parentemail')),
      expression: "errors.has('parentemail')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v(_vm._s(_vm.errors.first('parentemail')))])])]), _c('div', {
    staticClass: "form-dental-health-month__group__radio"
  }, [_c('label', {
    staticClass: "form-dental health-month__label",
    class: {
      'form-contact__label--active': _vm.yes_no
    }
  }, [_vm._v("Has your child had an Orthodontic Evaluation?")]), _c('label', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yes_no),
      expression: "yes_no"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental health-month__input",
    class: {
      'form-contact__input--error': _vm.errors.has('yes_no')
    },
    attrs: {
      "name": "yes_no",
      "checked": "checked",
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.yes_no, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.yes_no = "Yes"
      }
    }
  }), _c('span', [_vm._v("Yes")])]), _c('label', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yes_no),
      expression: "yes_no"
    }],
    staticClass: "form-dental health-month__input",
    class: {
      'form-contact__input--error': _vm.errors.has('yes_no')
    },
    attrs: {
      "name": "yes_no",
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.yes_no, "No")
    },
    on: {
      "change": function($event) {
        _vm.yes_no = "No"
      }
    }
  }), _c('span', [_vm._v("No")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('yes_no')),
      expression: "errors.has('yes_no')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v("Please select one.")])]), _c('div', {
    staticClass: "form-dental-health-month__group__radio"
  }, [_c('label', {
    staticClass: "form-dental health-month__label",
    class: {
      'form-contact__label--active': _vm.ortho_eval_yes_no
    }
  }, [_vm._v("Would you like us to reach out and schedule a free Orthodontic Evaluation and receive a $250 Gift Certificate towards orthodontic treatment?")]), _c('label', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ortho_eval_yes_no),
      expression: "ortho_eval_yes_no"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-dental health-month__input",
    class: {
      'form-contact__input--error': _vm.errors.has('ortho_eval_yes_no')
    },
    attrs: {
      "name": "ortho_eval_yes_no",
      "checked": "checked",
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.ortho_eval_yes_no, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.ortho_eval_yes_no = "Yes"
      }
    }
  }), _c('span', [_vm._v("Yes")])]), _c('label', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ortho_eval_yes_no),
      expression: "ortho_eval_yes_no"
    }],
    staticClass: "form-dental health-month__input",
    class: {
      'form-contact__input--error': _vm.errors.has('ortho_eval_yes_no')
    },
    attrs: {
      "name": "ortho_eval_yes_no",
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.ortho_eval_yes_no, "No")
    },
    on: {
      "change": function($event) {
        _vm.ortho_eval_yes_no = "No"
      }
    }
  }), _c('span', [_vm._v("No")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ortho_eval_yes_no')),
      expression: "errors.has('ortho_eval_yes_no')"
    }],
    staticClass: "form-dental-health-month__danger"
  }, [_vm._v("Please select one.")])]), _vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dental-health-month__intro-group"
  }, [_c('div', {
    staticClass: "form-dental-health-month__intro-group__text"
  }, [_c('h3', {
    staticClass: "form-dental-health-month__intro"
  }, [_vm._v("Welcome!")]), _c('p', {
    staticClass: "form-dental-health-month__body"
  }, [_vm._v("Chenin Orthodontic Group has partnered with local schools, sports teams, and other organizations to bring out the very best in your child for over 45 years. As community partners, we have helped raise money for the PTA’s , participated in Fall Festivals, hosted Oral Health presentations, sponsored sports organizations, volunteered to help non-profits, and so much more.")]), _c('p', {
    staticClass: "form-dental-health-month__body"
  }, [_vm._v("To support Children’s National Dental Heath Month and Orthodontic Awareness Month, we want every child to have great dental health, oral hygiene techniques, and make healthy nutritional lifestyle choices.")])]), _c('div', {
    staticClass: "form-dental-health-month__intro-group__video"
  }, [_c('iframe', {
    staticClass: "form-dental-health-month",
    attrs: {
      "width": "420",
      "height": "236",
      "src": "https://www.youtube.com/embed/0z0he3f9u90?si=yPVHGTlFeHsF6ppW",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dental-health-month__group"
  }, [_c('input', {
    staticClass: "form-dental-health-month__submit-button",
    attrs: {
      "type": "submit",
      "value": "Send"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501b8a86","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form-dental-health-month/form-dental-health-month.pug
// module id = 643
// module chunks = 1